import { createSlice } from "@reduxjs/toolkit"
import api from "../../api/services"
import { Step1Response } from "../../api/types/step1"

type initialState = {
    response: Step1Response | null
}

const applySlice = createSlice({
    name: "step1",
    initialState: { response: null } as initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addMatcher(
            api.endpoints.step1.matchFulfilled,
            (state, action) => {
                state.response = action.payload
            }
        )
    }
})

export default applySlice.reducer




